import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Our own address book (backend table `postcodes`), filled from the
// addresses customers pick with "Find address". Super admins only.
export interface PostcodeAddress {
  id?: number;
  address1: string;
  address2: string;
  city: string;
  county: string;
  postalcode: string;
}

export interface PostcodePage {
  rows: PostcodeAddress[];
  total: number;
  page: number;
  pageSize: number;
  // Whole table (summary tiles). Older backends don't send it.
  stats?: { addresses: number; postcodes: number; counties: number };
}

@Injectable({ providedIn: 'root' })
export class PostcodesService {
  constructor(private http: HttpClient) {}

  list(q: string, page: number, pageSize: number): Observable<PostcodePage> {
    const params = new URLSearchParams({ q: q || '', page: String(page), pageSize: String(pageSize) });
    return this.http.get<PostcodePage>(`/address/admin?${params.toString()}`);
  }

  create(a: PostcodeAddress): Observable<PostcodeAddress> {
    return this.http.post<PostcodeAddress>('/address/admin', a);
  }

  update(id: number, a: PostcodeAddress): Observable<PostcodeAddress> {
    return this.http.put<PostcodeAddress>(`/address/admin/${id}`, a);
  }

  remove(id: number): Observable<unknown> {
    return this.http.delete(`/address/admin/${id}`);
  }
}
